/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA
 */

import { ensureMomentLocale } from '@oat-sa-private/ui-core';
import { init as initDateFormatConfig } from '@/core/utils/dateFormatConfig.js';
import { preloadMomentLocaleData } from '@/core/utils/momentLocalePreload.js';

export const DEFAULT_DATE_FORMAT_LOCALE = 'en-US';

/**
 * Applies date format settings after moment locale data is loaded.
 * @param {{ enabled?: boolean, dateFormats?: Record<string, object>, locale?: string }} settings
 */
export async function applyDateFormatSettings({
    enabled = false,
    dateFormats = {},
    locale = DEFAULT_DATE_FORMAT_LOCALE
} = {}) {
    const activeLocale = locale || DEFAULT_DATE_FORMAT_LOCALE;

    await preloadMomentLocaleData(activeLocale);
    await ensureMomentLocale(activeLocale);

    initDateFormatConfig({
        enabled,
        dateFormats,
        locale: activeLocale
    });
}
